// Classes.
import { BaseLocator } from "./../locators/base.locator";
import { CategoryIdLocatorComponent } from "./categoryid.locator-component";
import { CardinalityLocatorComponent } from "./cardinality.locator-component";
import { ParaArcheryLocatorComponent } from "./paraarchery.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";
import { StringLocatorComponent } from './string.locator-component';
import { CategoryCardinalityStruct } from '../util/category-cardinality.struct';

export class RecordListLocator extends BaseLocator {
  recordLevel: CategoryIdLocatorComponent;
  disciplineId: CategoryIdLocatorComponent;
  team: CardinalityLocatorComponent;
  isPara: ParaArcheryLocatorComponent;
  isHistorical: CardinalityLocatorComponent;
  category: CategoryCardinalityStruct;
  search: StringLocatorComponent;
  public sortrank: RankSortingLocatorComponent;

  constructor() {
    super("recordList");
    this.addComponentByType("catid", "recordLevel");
    this.addComponentByType("catid", "disciplineId");
    this.addComponentByType("team", "team");
    this.addComponentByType("isPara", "isPara");
    this.addComponentByType("team", "isHistorical");
    this.addComponentByType("catcode", "category");
    this.addComponentByType("search");
    this.addComponentByType("sortrank", "sortrank");
  }
}
